import * as e from "react";
const l = (h) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...h
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GB-UKM_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#GB-UKM_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GB-UKM_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#GB-UKM_svg__b)" }, /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "GB-UKM_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#GB-UKM_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-3.564 22.286l7.041 2.978L32.158 3.238l3.715-4.425-7.53-.996L16.644 7.31l-9.416 6.395-10.792 8.582z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.6 24.372l3.588 1.729L34.54-1.6h-5.037L-2.6 24.373z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M35.563 22.286l-7.042 2.978L-.16 3.238l-3.715-4.425 7.53-.996L15.354 7.31l9.416 6.395 10.793 8.582z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M35.322 23.784l-3.587 1.728-14.287-11.86-4.236-1.325L-4.232-1.172H.805L18.24 12.007l4.63 1.589 12.452 10.188z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement("mask", { id: "GB-UKM_svg__d", fill: "#fff" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.778-2h-7.555V8H-1.973v8h14.196v10h7.555V16h14.25V8h-14.25V-2z"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.778-2h-7.555V8H-1.973v8h14.196v10h7.555V16h14.25V8h-14.25V-2z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.223-2v-2h-2v2h2zm7.555 0h2v-2h-2v2zM12.223 8v2h2V8h-2zM-1.973 8V6h-2v2h2zm0 8h-2v2h2v-2zm14.196 0h2v-2h-2v2zm0 10h-2v2h2v-2zm7.555 0v2h2v-2h-2zm0-10v-2h-2v2h2zm14.25 0v2h2v-2h-2zm0-8h2V6h-2v2zm-14.25 0h-2v2h2V8zm-7.555-8h7.555v-4h-7.555v4zm2 8V-2h-4V8h4zm-16.196 2h14.196V6H-1.973v4zm2 6V8h-4v8h4zm12.196-2H-1.973v4h14.196v-4zm2 12V16h-4v10h4zm5.555-2h-7.555v4h7.555v-4zm-2-8v10h4V16h-4zm16.25-2h-14.25v4h14.25v-4zm-2-6v8h4V8h-4zm-12.25 2h14.25V6h-14.25v4zm-2-12V8h4V-2h-4z",
      fill: "#fff",
      mask: "url(#GB-UKM_svg__d)"
    }
  ))))
);
export {
  l as default
};
